module.exports = __webpack_public_path__ + "media/src/images/error-message-grey-a57435fce8998d0024ea4d6af13638f4.png";